import { render } from "./TopMessage.vue?vue&type=template&id=7651b862"
import script from "./TopMessage.vue?vue&type=script&lang=js"
export * from "./TopMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__